import { message } from 'antd'
import { useAxios } from 'zhooks'

export function useSetTop(onSuccess) {
  const { runAsync } = useAxios(async (axios, folderId) => {
    const res = await axios.get('/backend-api/zhikuan/mn/sample/folder/folder-set-top', { params: { folderId } })
    if (res.data) {
      message.success('置顶成功')
    }
  }, { manual: true, onSuccess })
  return runAsync
}

export function useUnsetTop(onSuccess) {
  const { runAsync } = useAxios(async (axios, folderId) => {
    const res = await axios.get('/backend-api/zhikuan/mn/sample/folder/folder-cancel-top', { params: { folderId } })
    if (res.data) {
      message.success('取消置顶成功')
    }
  }, { manual: true, onSuccess })
  return runAsync
}
